import React from 'react';
import stylex from '@stylexjs/stylex';
import { SettingsIcon, UploadIcon } from '@shared/assets/icons';
import { Tooltip } from '@shared/ui/tooltip';
import { styles } from './styles';

export interface HeaderActionsProps {
  onExport: () => void;
  onSettingsClick: () => void;
}

export const HeaderActions = React.memo<HeaderActionsProps>(({ onExport, onSettingsClick }) => (
  <div {...stylex.props(styles.actions)}>
    <Tooltip position="bottom" title="Экспортировать всех участников в excel" {...stylex.props(styles.tooltip)}>
      <button {...stylex.props(styles.exportControl)} onClick={onExport}>
        <UploadIcon />
      </button>
    </Tooltip>
    <button {...stylex.props(styles.settingsControl)} onClick={onSettingsClick}>
      <SettingsIcon />
    </button>
  </div>
));
